import {StyleSheet, View} from 'react-native'

import {useWebMediaQueries} from '#/lib/hooks/useWebMediaQueries'
import {isWeb} from '#/platform/detection'
import {ChatBubbleProvider, useChatBubble} from '#/state/chat-bubble'
import {usePresenceHeartbeat} from '#/state/chat-bubble/presence'
import {useSession} from '#/state/session'
import {ChatBubbleButton} from '#/components/chat-bubble/ChatBubbleButton'
import {FloatingChatWindow} from '#/components/chat-bubble/FloatingChatWindow'
import {OnlineUsersPanel} from '#/components/chat-bubble/OnlineUsersPanel'

export function ChatBubbleRoot() {
  const {hasSession} = useSession()

  if (!isWeb || !hasSession) return null

  return (
    <ChatBubbleProvider>
      <ChatBubbleContainer />
    </ChatBubbleProvider>
  )
}

function ChatBubbleContainer() {
  const {openWindows, isBubbleOpen} = useChatBubble()
  const {isDesktop} = useWebMediaQueries()
  usePresenceHeartbeat()

  return (
    <View
      testID="chat-bubble-root"
      style={[styles.root, !isDesktop && styles.rootMobile]}>
      <View style={styles.bubbleColumn}>
        <ChatBubbleButton />
        {isBubbleOpen && <OnlineUsersPanel />}
      </View>
      {openWindows.map(win => (
        <FloatingChatWindow key={win.id} window={win} />
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  root: {
    position: 'fixed' as any,
    bottom: 20,
    right: 20,
    zIndex: 5,
    flexDirection: 'row-reverse',
    alignItems: 'flex-end',
    gap: 8,
    pointerEvents: 'none',
  },
  rootMobile: {
    bottom: 90,
  },
  bubbleColumn: {
    alignItems: 'flex-end',
    pointerEvents: 'auto' as any,
  },
})
